var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.7,443.3l-144-144C1.6,296.2,0,292.1,0,288s1.6-8.2,4.7-11.3l144-144c6.2-6.2,16.4-6.2,22.6,0 s6.2,16.4,0,22.6L54.6,272H432c26.5,0,48-21.5,48-48V48c0-8.8,7.2-16,16-16s16,7.2,16,16v175.1c0,45-35.9,80.9-80,80.9H54.6 l116.7,116.7c6.2,6.2,6.2,16.4,0,22.6S154.9,449.6,148.7,443.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.59f5848b5e41316ab5fa205c31aa2830.svg";
export { ForwardRef as ReactComponent };